export const logoDevBaseUrl = 'https://img.logo.dev';
export const logoDevToken = 'pk_LDZDoKzUQoi-WnyBZgI2SQ';

export function getLogoUrl(domain: string): string {
  return `${logoDevBaseUrl}/${domain}?token=${logoDevToken}&fallback=404`;
}
